const KEY_PREFIX = 'velox:physical-card-prompt:';

export function physicalCardPromptKey(userId) {
  return `${KEY_PREFIX}${userId}`;
}

export function hasSeenPhysicalCardPrompt(userId) {
  if (!userId) return true;
  return localStorage.getItem(physicalCardPromptKey(userId)) === 'seen';
}

export function markPhysicalCardPromptSeen(userId) {
  if (!userId) return;
  localStorage.setItem(physicalCardPromptKey(userId), 'seen');
}

/** First Contacts visit, and only when this account has no active physical card. */
export function shouldOfferPhysicalCardPrompt(userId, physicalCards) {
  if (!userId || hasSeenPhysicalCardPrompt(userId)) return false;
  const active = Array.isArray(physicalCards)
    && physicalCards.some((card) => card && card.status === 'active');
  return !active;
}
